import type React from 'react';

import type { IconProps } from 'types/icon';

const User: React.FC<IconProps> = ({
  size = '16',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M10 13.314C11.9005 13.314 13.7583 13.7808 15.2884 14.6566C16.8179 15.532 17.9493 16.775 18.4697 18.218C18.5658 18.4845 18.4261 18.778 18.1577 18.8735C17.8893 18.9688 17.594 18.8301 17.4979 18.5637C17.0751 17.3913 16.1328 16.3226 14.7731 15.5444C13.4139 14.7665 11.7367 14.3389 10 14.3389C8.26307 14.3389 6.58211 14.767 5.22785 15.5444H5.22702C3.86729 16.3226 2.92496 17.3913 2.50214 18.5637C2.40604 18.8301 2.11077 18.9688 1.84239 18.8735C1.57396 18.778 1.43424 18.4845 1.53035 18.218C2.05076 16.7751 3.18161 15.5319 4.71084 14.6566C6.23735 13.7803 8.09996 13.314 10 13.314Z"
        fill={color}
      />
      <path
        d="M13.618 5.61732C13.618 3.63353 11.9983 2.02508 10.0002 2.02497C8.00206 2.02497 6.38197 3.63347 6.38197 5.61732C6.38208 7.60109 8.00213 9.20926 10.0002 9.20926C11.9982 9.20916 13.6179 7.60102 13.618 5.61732ZM14.6504 5.61732C14.6503 8.16717 12.5684 10.2341 10.0002 10.2342C7.4319 10.2342 5.34972 8.16724 5.34961 5.61732C5.34961 3.06732 7.43183 1 10.0002 1C12.5685 1.00011 14.6504 3.06738 14.6504 5.61732Z"
        fill={color}
      />
    </svg>
  );
};

export default User;
